import React from "react";
import { Spinner } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";

const CustomerBlockModal = ({
  handleBlockModalClose,
  data,
  onAction,
  loading,
  forBlock,
}) => {
  return (
    <div>
      <ModalContainer handleClose={handleBlockModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0">
              Confirm {forBlock ? "BLock" : "UnBlock"}
            </p>
            <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleBlockModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div>
            <p>
              Do you want to {forBlock ? "block " : "un-block "}
              <b>
                {`${data?.firstname === "-" ? "" : data?.firstname || ""} ${
                  data?.lastname === "-" ? "" : data?.lastname || ""
                }`.trim() ||
                  data?.email ||
                  "this user"}
              </b>
              ?
            </p>

            <div className="d-flex justify-content-center align-items-center">
              <div
                className="d-flex justify-content-center align-items-center rounded-3 p-2 mx-2 bg-dark text-white"
                role="button"
                onClick={handleBlockModalClose}
              >
                <span className={`mx-2 d-flex`}>Cancel</span>
              </div>

              <div
                className="d-flex justify-content-center align-items-center rounded-3 p-2 mx-2 bg-danger text-white"
                role="button"
                onClick={() => {
                  onAction(data.slug, forBlock);
                }}
              >
                <span className={`mx-2 d-flex`}>
                  {loading ? (
                    <Spinner animation="grow" size="sm" className="mx-3 my-1" />
                  ) : forBlock ? (
                    "Block"
                  ) : (
                    "Unblock"
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default CustomerBlockModal;
